import { RootState } from 'store/root-reducer';

export const jobTypeSummarySelector = ({ jobType }: RootState) => jobType.summary;
